import {
  createModelSchema,
  identifier,
  list,
  map,
  object,
  primitive,
  optional
} from 'serializr'
import { EventGroup } from './eventGroup'
import { Customer } from './customer'
import { Participant } from './participant'
import { Cart } from './cart'
import { Discount, DiscountRule } from './discount'
import { Addon } from './addon'

export function createModelSchemas() {
  createModelSchema(Cart, {
    eventGroupsStore: map(object(EventGroup)),
    customer: object(Customer),
    coupon: true,
    couponTitle: true
  })

  createModelSchema(EventGroup, {
    id: identifier(),
    addons: list(object(Addon)),
    participants: list(object(Participant)),
    title: true,
    pricePerParticipant: true,
    vatPerParticipant: true,
    first_date: true,
    location: true,
    subtitle: true,
    discountsAvailable: map(primitive()),
    featured_image: true,
    spots_left: true,
    category: true,
    chosen_addons: list(object(Addon)),
    ga4_tracking_item: optional(map(primitive())),
    requiredFields: map(list(primitive()))
  })

  createModelSchema(Addon, {
    id: true,
    title: true,
    subtitle: true,
    price: true,
    vat : true,
    spots_left: true,
    participants: list(object(Participant)),
    ga4_tracking_item: optional(map(primitive()))
  })

  createModelSchema(Participant, {
    id: true,
    name: true,
    position: true,
    email: true,
    _hasNewsletterDiscount: true,
    discounts: map(list(object(Discount))),
    price: true,
    vat: true,
    newslette: true,
  })
  createModelSchema(Discount, {
    name: true,
    discount: true
  })
  createModelSchema(DiscountRule, {
    Amount: true,
    IsPercent: true,
    Id: true
  })
  createModelSchema(Customer, {
    type: true,
    ean: true,
    cvr: true,
    name: true,
    location: true,
    department: true,
    address: true,
    zip_code: true,
    city: true,
    invoice_email: true,
    email: true,
    phone: true,
    person_ref: true,
    order_nr: true,
    heard_about: true,
    heard_about_value: true,
    payment_method: true
  })
}
